function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from "styled-components";
import { setColor } from '../../../helpers/styleUtils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/pro-light-svg-icons";
const StyledLogoImg = styled.img`
  max-width: 100%;
  max-height: 15rem;
`;
const StyledLogoWrapper = styled.div`
  width: 100%;
  text-align: center;
`;
const StyledDefaultLogo = styled.div`
  width: 20rem;
  height: 5rem;
  line-height: 5rem;
  border: 1px ${setColor.cloudy} dashed;
  color: ${setColor.cloudy};
  font-size: 1.5rem;
`;

class Logo extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderDefaultLogo", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLogoWrapper, null, /*#__PURE__*/React.createElement(StyledDefaultLogo, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faImage
      }))));
    });

    _defineProperty(this, "renderLogoWithImage", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLogoWrapper, null, /*#__PURE__*/React.createElement(StyledLogoImg, {
        src: this.props.resource.logo.url,
        alt: "logo"
      })));
    });

    _defineProperty(this, "renderLogo", () => {
      return !!this.props.resource.logo ? this.renderLogoWithImage() : this.renderDefaultLogo();
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderLogo());
    });
  }

}

export default Logo;